import { gql } from "@apollo/client";

export const GET_ATTACHED_STACK_INTEGRATIONS = gql`
  query GetAttachedStackIntegrations($stackId: ID!) {
    stack(id: $stackId) {
      id
      integrations {
        awsV2 {
          id
          read
          write
          durationSeconds
          externalId
          name
          roleArn
          isAutoattached
          labels
        }
        azure {
          id
          read
          write
          defaultSubscriptionId
          subscriptionId
          integrationName
          isAutoattached
          labels
        }
      }
    }
  }
`;
